import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';
import { keyByProperty } from '../../../helpers/core';
import { t } from '../../../i18n';

const paystubsApi = new Api('paystubs');

function* uploadPaystub(data) {
  try {
    const { payload } = data;
    const { editPaystubForm } = payload;

    const propsArray = Object.values(editPaystubForm);
    const paystub = keyByProperty(propsArray, 'name', prop => prop.value);

    const formData = new FormData();
    formData.append('paystub[file]', paystub.file);

    const result = yield call(sendRequest, paystubsApi.sendFormData, { data: formData }, notifications.REQUEST_ERROR);

    if (result) {
      if (result.data) {
        yield put(
          actions.saveSuccess({
            data: paystub,
          }),
        );
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.uploaded_successfully', {
              item: t('dash.admin.payroll.paystub_title'),
            }),
          }),
        );
      } else {
        yield put(
          actions.saveError({
            data: result,
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export { uploadPaystub };
export default function* rootSaga() {
  yield all([takeEvery(actions.UPLOAD_PAYSTUB, uploadPaystub)]);
}
